import { Customer, Address } from '../interfaces/Customer';
import { isStringOfWords, isNotEmpty, isNumber, isEmail, isPhoneNumber } from './Validators';

export interface CustomerValidationState {
  name: boolean;
  email: boolean;
  customerNumber: boolean;
  contactPerson: boolean;
  contactPersonFunction: boolean;
  phone: boolean;
  address: AddressValidationState;
  type: boolean;
  additionalAddresses: boolean;
}
export interface AddressValidationState {
  street: boolean;
  city: boolean;
  streetNumber: boolean;
  zip: boolean;
  country?: boolean;
  thermalLine?: boolean;
  type?: boolean;
  consumption?: boolean;
  unit?: boolean;
  supplier?: boolean;
}
export const getInitialValidationState = () => {
  return {
    name: false,
    email: false,
    customerNumber: false,
    contactPerson: false,
    contactPersonFunction: false,
    phone: false,
    address: {
      street: false,
      city: false,
      streetNumber: false,
      zip: false,
      country: false,
    },
    type: false,
    additionalAddresses: false,
  };
};

export const validate = (customer: Customer) => {
  const state = {
    name: !isNotEmpty(customer?.name),
    email: !isEmail(customer?.email),
    customerNumber: !isNotEmpty(customer?.customerNumber),
    contactPerson: !isStringOfWords(customer?.contactPerson),
    contactPersonFunction: !isStringOfWords(customer?.contactPerson),
    phone: !isPhoneNumber(customer?.phone),
    address: validateAddress(customer?.address),
    type: !isNotEmpty(customer?.type),
    additionalAddresses: validateAddresses(customer?.additionalAddresses || [], false),
  };
  return state;
};
const validateAddresses = (addresses: Address[], validateCountries: boolean = false) => {
  for (let address of addresses || []) {
    const isValid = isValidAddressState(validateAddress(address, validateCountries));
    if (!isValid) return true;
  }
  return false;
};
//TODO replace with proper validators from Validators.ts
export const validateAddress = (address: any, validateCountry: boolean = true) => {
  const state = {
    street: address?.street && address?.street.length > 0 ? false : true,
    streetNumber: address?.streetNumber && address?.streetNumber.length > 0 ? false : true,
    zip: address?.zip && address?.zip.length > 0 ? false : true,
    city: address?.city && address?.city.length > 0 ? false : true,
  };
  if (validateCountry) state['country'] = address?.country && address?.country.length > 0 ? false : true;
  return state;
};
export const isValidAddressState = (addressState: AddressValidationState) => {
  return Object.values(addressState).every((value) => value === false);
};
export const isValidAddressArray = (addresses: any[]) => {
  return addresses.every((address) => isValidAddressState(address));
};

export const isValidState = (state: CustomerValidationState) => {
  for (let key in state) {
    if (key == 'address') {
      if (!isValidAddressState(state.address)) return false;
      continue;
    }
    if (state[key] == true) return false;
  }
  return true;
};
